import React, { useEffect, useState, useRef } from 'react';

import { useParams, useNavigate } from 'react-router-dom';

import {

  Box,

  Typography,

  Paper,

  CircularProgress,

  Button,

  Grid,

  Stack,

  Divider,

  Alert,

  Chip,

  IconButton,

  TextField,

  MenuItem,

  Snackbar,

} from '@mui/material';

import {

  ArrowBack as ArrowBackIcon,

  Download as DownloadIcon,

  CheckCircle as CheckCircleIcon,

  CheckCircleOutline as CheckCircleOutlineIcon,

  Warning as WarningIcon,

  WarningAmber as WarningAmberIcon,

  Error as ErrorIcon,

  ErrorOutline as ErrorOutlineIcon,

  Info as InfoIcon,

  BugReport as BugReportIcon,

  Share as ShareIcon,

} from '@mui/icons-material';

import { useAuth } from '../../contexts/AuthContext';

import { useTranslation } from 'react-i18next';

import api from '../../services/api';

import jsPDF from 'jspdf';

import autoTable from 'jspdf-autotable';



const DetalleAnalisis = () => {

  const { analysisSeq } = useParams();

  const { user } = useAuth();

  const navigate = useNavigate();

  const { t } = useTranslation();



  const [loading, setLoading] = useState(true);

  const [report, setReport] = useState(null);

  const [error, setError] = useState(null);

  const [snackbarOpen, setSnackbarOpen] = useState(false);

  const [snackbarMessage, setSnackbarMessage] = useState('');

  const [isGeneratingPDF, setIsGeneratingPDF] = useState(false);

  const [expandedCards, setExpandedCards] = useState({});

  const [filterType, setFilterType] = useState(null);



  // Ref para el contenedor exportable

  const pdfRef = useRef();

  // Ref para la sección de items

  const itemsSectionRef = useRef();



  const toggleCardExpansion = (cardId) => {

    setExpandedCards(prev => ({

      ...prev,

      [cardId]: !prev[cardId]

    }));

  };



  const scrollToItems = (type) => {

    if (itemsSectionRef.current) {

      setFilterType(type);

      // Desplazar a la sección de items con un pequeño offset para el header

      const yOffset = -100;

      const element = itemsSectionRef.current;

      const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;

      window.scrollTo({ top: y, behavior: 'smooth' });

    }

  };

  useEffect(() => {
    const fetchReport = async () => {
      try {
        setLoading(true);
        const response = await api.get(`/customer-report/${user.id}/${analysisSeq}`);
        const reportData = response.data.sanitizedCustomerReport;
        
        if (reportData) {
          // Parse the JSON fields if they're strings
          if (typeof reportData.analysis_report === 'string') {
            reportData.analysis_report = JSON.parse(reportData.analysis_report);
          }
          if (typeof reportData.analysis_details === 'string') {
            reportData.analysis_details = JSON.parse(reportData.analysis_details);
          }
          
          setReport(reportData);
        }
      } catch (error) {
        setError(t('Error al cargar el reporte'));
      } finally {
        setLoading(false);
      }
    };

    fetchReport();
    window.scrollTo(0, 0);
  }, [analysisSeq, user.id, t]);

  const getScoreColor = (score) => {

    const numScore = typeof score === 'string' ? parseFloat(score) : score;

    if (numScore >= 90) return '#4caf50';

    if (numScore >= 70) return '#ff9800';

    return '#f44336';

  };



  const getSeverityIcon = (severity) => {

    switch(severity) {

      case 'critical':

        return <ErrorIcon color="error" fontSize="small" />;

      case 'serious':

        return <WarningIcon color="warning" fontSize="small" />;

      case 'moderate':

        return <InfoIcon color="info" fontSize="small" />;

      case 'minor':

        return <BugReportIcon fontSize="small" sx={{ color: '#9e9e9e' }} />;

      default:

        return null;

    }

  };



  const getSeverityColor = (severity) => {

    switch(severity) {

      case 'critical': return 'error';

      case 'serious': return 'warning';

      case 'moderate': return 'info';

      case 'minor': return 'default';

      default: return 'default';

    }

  };



  // Función para generar el PDF (reutilizable)
  const generatePDF = async () => {
    if (!report) {
      return null;
    }

    const pdf = new jsPDF({
      orientation: 'portrait',
      unit: 'mm',
      format: 'a4',
    });

    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();
    const margin = 15;
    const contentWidth = pageWidth - (margin * 2);
    let yPosition = margin;

    // Añadir logo, texto y enlace en la esquina superior derecha
    const logoSize = 15;
    const logoX = pageWidth - margin - logoSize;
    const logoY = margin;
    
    try {
      const img = new Image();
      img.crossOrigin = 'anonymous';
      
      await new Promise((resolve, reject) => {
        img.onload = () => {
          try {
            // Logo (15x15mm - reducido de 20x20mm)
            pdf.addImage(img, 'PNG', logoX, logoY, logoSize, logoSize);
          } catch (err) {
          }
          resolve();
        };
        img.onerror = (err) => {
          resolve();
        };
        setTimeout(() => {
          resolve();
        }, 500);
        
        img.src = '/favicon.png';
      });
    } catch (error) {
    }

    // Texto "viewser" debajo del logo (más espacio y en negro)
    pdf.setFontSize(11);
    pdf.setFont('helvetica', 'bold');
    pdf.setTextColor(0, 0, 0);
    const viewserText = 'viewser';
    const viewserWidth = pdf.getTextWidth(viewserText);
    const viewserX = logoX + (logoSize / 2) - (viewserWidth / 2);
    pdf.text(viewserText, viewserX, logoY + logoSize + 6);

    // URL debajo del texto viewser
    pdf.setFontSize(8);
    pdf.setFont('helvetica', 'normal');
    pdf.setTextColor(15, 82, 189);
    const websiteText = 'goviewser.com';
    const websiteWidth = pdf.getTextWidth(websiteText);
    const websiteX = logoX + (logoSize / 2) - (websiteWidth / 2);
    pdf.textWithLink(websiteText, websiteX, logoY + logoSize + 11, { url: 'https://goviewser.com/' });
    pdf.setTextColor(0, 0, 0);

    // Función para añadir nueva página si es necesario
    const checkPageBreak = (requiredSpace = 10) => {
      if (yPosition + requiredSpace > pageHeight - margin) {
        pdf.addPage();
        yPosition = margin;
        return true;
      }
      return false;
    };

    // Título principal
    pdf.setFontSize(20);
    pdf.setFont('helvetica', 'bold');
    pdf.setTextColor(15, 82, 189); // Color azul #0F52BD
    pdf.text(t('Reporte de Accesibilidad'), margin, yPosition);
    yPosition += 10;

    // URL analizada
    pdf.setFontSize(11);
    pdf.setFont('helvetica', 'normal');
    pdf.setTextColor(100, 100, 100);
    const url = report.url || `${report.domain}${report.path}`;
    const urlLines = pdf.splitTextToSize(url, contentWidth);
    pdf.text(urlLines, margin, yPosition);
    yPosition += urlLines.length * 5 + 5;

    // Fecha del análisis
    pdf.setFontSize(10);
    const analysisDate = new Date(report.analysis_date).toLocaleString(
      t('Spanish') === 'Español' ? 'es-ES' : 'en-US',
      {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      }
    );
    pdf.text(`${t('Fecha del informe')}: ${analysisDate}`, margin, yPosition);
    yPosition += 10;

    // Línea separadora
    pdf.setDrawColor(200, 200, 200);
    pdf.line(margin, yPosition, pageWidth - margin, yPosition);
    yPosition += 15;

    // Puntuación
    checkPageBreak(35);
    pdf.setFontSize(14);
    pdf.setFont('helvetica', 'bold');
    pdf.setTextColor(0, 0, 0);
    pdf.text(t('Puntuación obtenida'), margin, yPosition);
    yPosition += 14;

    const score = parseFloat(report.accesibility_score) || 0;
    const scoreText = score % 1 === 0 ? score.toFixed(0) : score.toFixed(1);
    pdf.setFontSize(36);
    
    // Color según puntuación
    if (score >= 90) pdf.setTextColor(76, 175, 80);
    else if (score >= 70) pdf.setTextColor(255, 152, 0);
    else pdf.setTextColor(244, 67, 54);
    
    pdf.text(`${scoreText}/100`, margin, yPosition);
    yPosition += 20;

    // Resumen de resultados
    const summary = report.analysis_details?.summary || {};
    const violations = report.analysis_report?.violations || [];
    const incomplete = report.analysis_report?.incomplete || [];

    checkPageBreak(40);
    pdf.setFontSize(12);
    pdf.setFont('helvetica', 'bold');
    pdf.setTextColor(0, 0, 0);
    pdf.text(t('Resumen de resultados'), margin, yPosition);
    yPosition += 8;

    // Tabla de resumen
    autoTable(pdf, {
      startY: yPosition,
      head: [[t('Categoría'), t('Cantidad')]],
      body: [
        [t('Incumplimientos'), summary.violations || 0],
        [t('Revisión manual'), summary.incomplete || 0],
        [t('Aprobados'), summary.passes || 0],
        [t('No aplicables'), summary.inapplicable || 0],
      ],
      margin: { left: margin, right: margin },
      styles: { fontSize: 10 },
      headStyles: { fillColor: [15, 82, 189], textColor: 255 },
      columnStyles: {
        0: { cellWidth: contentWidth * 0.7 },
        1: { cellWidth: contentWidth * 0.3, halign: 'center' }
      }
    });

    yPosition = pdf.lastAutoTable.finalY + 10;

    // Incumplimientos detallados
    if (violations.length > 0) {
      checkPageBreak(20);
      pdf.setFontSize(14);
      pdf.setFont('helvetica', 'bold');
      pdf.setTextColor(244, 67, 54);
      pdf.text(`${t('Incumplimientos')} (${violations.length})`, margin, yPosition);
      yPosition += 8;

      violations.forEach((violation, index) => {
        checkPageBreak(35);
        
        pdf.setFontSize(12);
        pdf.setFont('helvetica', 'bold');
        pdf.setTextColor(0, 0, 0);
        
        const title = `${index + 1}. ${violation.wcag?.criteria?.[0] || violation.id}`;
        pdf.text(title, margin, yPosition);
        yPosition += 8;

        // Descripción
        pdf.setFont('helvetica', 'normal');
        pdf.setFontSize(9);
        pdf.setTextColor(60, 60, 60);
        
        const helpText = t(`axeRules.${violation.id}.help`, { defaultValue: violation.help });
        const helpLines = pdf.splitTextToSize(helpText, contentWidth - 5);
        pdf.text(helpLines, margin + 2, yPosition);
        yPosition += helpLines.length * 4 + 4;

        // Gravedad con color
        pdf.setFont('helvetica', 'bold');
        const impactText = violation.impact === 'critical' ? t('Crítica') :
                          violation.impact === 'serious' ? t('Severa') :
                          violation.impact === 'moderate' ? t('Moderada') : t('Menor');
        pdf.text(`${t('Gravedad')}: `, margin + 2, yPosition);
        
        // Color según gravedad
        if (violation.impact === 'critical' || violation.impact === 'serious') {
          pdf.setTextColor(211, 47, 47);
        } else if (violation.impact === 'moderate') {
          pdf.setTextColor(237, 108, 2);
        } else {
          pdf.setTextColor(100, 100, 100);
        }
        pdf.setFont('helvetica', 'bold');
        pdf.text(impactText, margin + 2 + pdf.getTextWidth(`${t('Gravedad')}: `), yPosition);
        pdf.setTextColor(60, 60, 60);
        yPosition += 8;

        // Elementos afectados
        const nodes = violation.nodes || [];
        if (nodes.length > 0) {
          pdf.setFont('helvetica', 'bold');
          pdf.setFontSize(10);
          pdf.setTextColor(211, 47, 47); // Color rojo para incumplimientos
          pdf.text(`${t('Incumplimientos')} (${nodes.length}):`, margin + 2, yPosition);
          yPosition += 6;
          
          nodes.forEach((node, nodeIndex) => {
            checkPageBreak(25);
            
            // Encabezado del elemento con más contraste
            pdf.setFillColor(244, 67, 54); // Fondo rojo más fuerte
            pdf.rect(margin + 3, yPosition - 3.5, contentWidth - 6, 7, 'F');
            
            pdf.setFontSize(9);
            pdf.setFont('helvetica', 'bold');
            pdf.setTextColor(255, 255, 255); // Texto blanco
            pdf.text(`${t('Elemento')} ${nodeIndex + 1}`, margin + 5, yPosition);
            yPosition += 6;
            
            // Contenido del HTML con mejor contraste
            pdf.setFillColor(255, 245, 245); // Fondo muy claro rosado
            const htmlContent = node.html || node.target?.join(', ') || t('No hay fragmento de código disponible');
            const htmlLines = pdf.splitTextToSize(htmlContent, contentWidth - 22);
            const boxHeight = Math.min(htmlLines.length * 3.5 + 6, 60); // Máximo 60mm de altura
            
            pdf.rect(margin + 3, yPosition - 2, contentWidth - 6, boxHeight, 'F');
            pdf.setDrawColor(244, 67, 54); // Borde rojo fuerte
            pdf.setLineWidth(0.5);
            pdf.rect(margin + 3, yPosition - 2, contentWidth - 6, boxHeight, 'S');
            pdf.setLineWidth(0.2);
            
            pdf.setFont('courier', 'normal');
            pdf.setFontSize(8);
            pdf.setTextColor(0, 0, 0);
            
            // Limitar líneas si es muy largo
            const displayLines = htmlLines.slice(0, 14);
            pdf.text(displayLines, margin + 6, yPosition + 1);
            yPosition += boxHeight - 1;
            
            if (htmlLines.length > 14) {
              pdf.setFont('helvetica', 'italic');
              pdf.setFontSize(7);
              pdf.setTextColor(150, 150, 150);
              pdf.text('... (contenido truncado)', margin + 6, yPosition);
              yPosition += 3;
            }
            
            yPosition += 5;
          });
          
          pdf.setFont('helvetica', 'normal');
          pdf.setFontSize(9);
          pdf.setTextColor(60, 60, 60);
        } else {
          pdf.setFont('helvetica', 'normal');
          pdf.text(`${t('Elementos afectados')}: 0`, margin + 2, yPosition);
          yPosition += 5;
        }

        if (index < violations.length - 1) {
          checkPageBreak(5);
          pdf.setDrawColor(230, 230, 230);
          pdf.line(margin, yPosition, pageWidth - margin, yPosition);
          yPosition += 6;
        }
      });
    }

    // Criterios de revisión manual
    if (incomplete.length > 0) {
      checkPageBreak(20);
      pdf.setFontSize(14);
      pdf.setFont('helvetica', 'bold');
      pdf.setTextColor(237, 108, 2);
      pdf.text(`${t('Revisión manual')} (${incomplete.length})`, margin, yPosition);
      yPosition += 10;

      incomplete.forEach((item, index) => {
        checkPageBreak(30);
        
        pdf.setFontSize(12);
        pdf.setFont('helvetica', 'bold');
        pdf.setTextColor(0, 0, 0);
        
        const title = `${index + 1}. ${item.wcag?.criteria?.[0] || item.id}`;
        pdf.text(title, margin, yPosition);
        yPosition += 8;

        // Descripción
        pdf.setFont('helvetica', 'normal');
        pdf.setFontSize(9);
        pdf.setTextColor(60, 60, 60);
        
        const helpText = t(`axeRules.${item.id}.help`, { defaultValue: item.help });
        const helpLines = pdf.splitTextToSize(helpText, contentWidth - 5);
        pdf.text(helpLines, margin + 2, yPosition);
        yPosition += helpLines.length * 4 + 8;

        // Elementos para revisión manual
        const nodes = item.nodes || [];
        if (nodes.length > 0) {
          pdf.setFont('helvetica', 'bold');
          pdf.setFontSize(10);
          pdf.setTextColor(237, 108, 2); // Color naranja
          pdf.text(`${t('Elementos para revisar')} (${nodes.length}):`, margin + 2, yPosition);
          yPosition += 8;
          
          nodes.forEach((node, nodeIndex) => {
            checkPageBreak(25);
            
            // Encabezado del elemento con color naranja
            pdf.setFillColor(255, 152, 0); // Fondo naranja
            pdf.rect(margin + 3, yPosition - 3.5, contentWidth - 6, 7, 'F');
            
            pdf.setFontSize(9);
            pdf.setFont('helvetica', 'bold');
            pdf.setTextColor(255, 255, 255); // Texto blanco
            pdf.text(`${t('Elemento')} ${nodeIndex + 1}`, margin + 5, yPosition);
            yPosition += 6;
            
            // Contenido del HTML o selector CSS
            pdf.setFillColor(255, 248, 225); // Fondo muy claro naranja
            const htmlContent = node.html 
              ? node.html 
              : node.target?.length > 0 
                ? node.target.join(', ') 
                : t('No hay fragmento de código disponible');
            const htmlLines = pdf.splitTextToSize(htmlContent, contentWidth - 22);
            const boxHeight = Math.min(htmlLines.length * 3.5 + 6, 60);
            
            pdf.rect(margin + 3, yPosition - 2, contentWidth - 6, boxHeight, 'F');
            pdf.setDrawColor(255, 152, 0); // Borde naranja
            pdf.setLineWidth(0.5);
            pdf.rect(margin + 3, yPosition - 2, contentWidth - 6, boxHeight, 'S');
            pdf.setLineWidth(0.2);
            
            pdf.setFont('courier', 'normal');
            pdf.setFontSize(8);
            pdf.setTextColor(0, 0, 0);
            
            const displayLines = htmlLines.slice(0, 14);
            pdf.text(displayLines, margin + 6, yPosition + 1);
            yPosition += boxHeight - 1;
            
            if (htmlLines.length > 14) {
              pdf.setFont('helvetica', 'italic');
              pdf.setFontSize(7);
              pdf.setTextColor(150, 150, 150);
              pdf.text('... (contenido truncado)', margin + 6, yPosition);
              yPosition += 3;
            }
            
            yPosition += 5;
          });
          
          pdf.setFont('helvetica', 'normal');
          pdf.setFontSize(9);
          pdf.setTextColor(60, 60, 60);
        } else {
          pdf.setFont('helvetica', 'normal');
          pdf.text(`${t('Elementos para revisar')}: 0`, margin + 2, yPosition);
          yPosition += 5;
        }

        if (index < incomplete.length - 1) {
          checkPageBreak(5);
          pdf.setDrawColor(230, 230, 230);
          pdf.line(margin, yPosition, pageWidth - margin, yPosition);
          yPosition += 6;
        }
      });
    }

    // Pie de página en todas las páginas
    const totalPages = pdf.internal.getNumberOfPages();
    for (let i = 1; i <= totalPages; i++) {
      pdf.setPage(i);
      pdf.setFontSize(8);
      pdf.setTextColor(150, 150, 150);
      pdf.text(
        `${t('Página')} ${i} ${t('de')} ${totalPages}`,
        pageWidth / 2,
        pageHeight - 10,
        { align: 'center' }
      );
    }

    return pdf;
  };

  const handleExportPDF = async () => {
    if (!report) {
      setSnackbarMessage(t('Error al generar el PDF'));
      setSnackbarOpen(true);
      return;
    }

    try {
      setIsGeneratingPDF(true);
      setSnackbarMessage(t('Generando PDF...'));
      setSnackbarOpen(true);

      // Usar la función generatePDF
      const pdf = await generatePDF();
      
      if (!pdf) {
        setSnackbarMessage(t('Error al generar el PDF'));
        setSnackbarOpen(true);
        return;
      }

      // Generar nombre de archivo
      const urlOrDomain = report?.url || `${report?.domain}${report?.path}` || 'analisis';
      const cleanName = urlOrDomain.replace(/[^a-zA-Z0-9]/g, '-').substring(0, 50);
      const date = new Date(report?.analysis_date || Date.now())
        .toISOString()
        .split('T')[0];

      pdf.save(`Reporte-Accesibilidad-${cleanName}-${date}.pdf`);

      setSnackbarMessage(t('PDF generado exitosamente'));
      setSnackbarOpen(true);
    } catch (error) {
      setSnackbarMessage(t('Error al generar el PDF'));
      setSnackbarOpen(true);
    } finally {
      setIsGeneratingPDF(false);
    }
  };



  const handleSnackbarClose = () => {

    setSnackbarOpen(false);

  };



  if (loading) {

    return (

      <Box display="flex" justifyContent="center" alignItems="center" minHeight="400px">

        <CircularProgress />

      </Box>

    );

  }



  if (error) {

    return (

      <Box>

        <Button

          startIcon={<ArrowBackIcon />}

          onClick={() => navigate('/dashboard/analizador')}

          sx={{ mb: 2 }}

        >

          {t('Volver')}

        </Button>

        <Alert severity="error">{error}</Alert>

      </Box>

    );

  }



  if (!report) {

    return (

      <Box>

        <Button

          startIcon={<ArrowBackIcon />}

          onClick={() => navigate('/dashboard/analizador')}

          sx={{ mb: 2 }}

        >

          {t('Volver')}

        </Button>

        <Alert severity="warning">{t('No se encontró el reporte')}</Alert>

      </Box>

    );

  }



  const scoreValue = parseFloat(report.accesibility_score) || 0;

  const score = scoreValue % 1 === 0 ? scoreValue.toFixed(0) : scoreValue.toFixed(1);

  const violations = report.analysis_report?.violations || [];

  const passes = report.analysis_report?.passes || [];

  const incomplete = report.analysis_report?.incomplete || [];

  const inapplicable = report.analysis_report?.inapplicable || [];

  const summary = report.analysis_details?.summary || {};



  // Función para agrupar TODOS los items por criterio WCAG, independientemente del tipo

  const groupAllByCriteria = () => {

    const grouped = {};

    

    // Procesar violations

    violations.forEach(item => {

      const criteriaKey = item.wcag?.criteria?.[0] || item.id;

      

      if (!grouped[criteriaKey]) {

        grouped[criteriaKey] = {

          criteria: criteriaKey,

          criteriaName: item.wcag?.criteriaNames?.[0] || '',

          level: item.wcag?.level || '',

          impact: item.impact,

          help: item.help,

          description: item.description,

          helpUrl: item.helpUrl,

          type: 'violation', // Este será el tipo predominante

          violationNodes: [],

          incompleteNodes: [],

          passNodes: [],

          id: item.id,

          wcag: item.wcag,

          hasViolations: true,

          hasIncomplete: false,

          hasPasses: false

        };

      }

      

      grouped[criteriaKey].hasViolations = true;

      grouped[criteriaKey].type = 'violation'; // Violations tienen prioridad

      if (item.nodes) {

        grouped[criteriaKey].violationNodes.push(...item.nodes);

      }

    });

    

    // Procesar incomplete

    incomplete.forEach(item => {

      const criteriaKey = item.wcag?.criteria?.[0] || item.id;

      

      if (!grouped[criteriaKey]) {

        grouped[criteriaKey] = {

          criteria: criteriaKey,

          criteriaName: item.wcag?.criteriaNames?.[0] || '',

          level: item.wcag?.level || '',

          impact: item.impact,

          help: item.help,

          description: item.description,

          helpUrl: item.helpUrl,

          type: 'incomplete',

          violationNodes: [],

          incompleteNodes: [],

          passNodes: [],

          id: item.id,

          wcag: item.wcag,

          hasViolations: false,

          hasIncomplete: true,

          hasPasses: false

        };

      } else if (!grouped[criteriaKey].hasViolations) {

        // Solo establecer como incomplete si no hay violations

        grouped[criteriaKey].type = 'incomplete';

      }

      

      grouped[criteriaKey].hasIncomplete = true;

      if (item.nodes) {

        grouped[criteriaKey].incompleteNodes.push(...item.nodes);

      }

    });

    

    // Procesar passes

    passes.forEach(item => {

      const criteriaKey = item.wcag?.criteria?.[0] || item.id;

      

      if (!grouped[criteriaKey]) {

        grouped[criteriaKey] = {

          criteria: criteriaKey,

          criteriaName: item.wcag?.criteriaNames?.[0] || '',

          level: item.wcag?.level || '',

          impact: item.impact,

          help: item.help,

          description: item.description,

          helpUrl: item.helpUrl,

          type: 'pass',

          violationNodes: [],

          incompleteNodes: [],

          passNodes: [],

          id: item.id,

          wcag: item.wcag,

          hasViolations: false,

          hasIncomplete: false,

          hasPasses: true

        };

      } else if (!grouped[criteriaKey].hasViolations && !grouped[criteriaKey].hasIncomplete) {

        // Solo establecer como pass si no hay violations ni incomplete

        grouped[criteriaKey].type = 'pass';

      }

      

      grouped[criteriaKey].hasPasses = true;

      if (item.nodes) {

        grouped[criteriaKey].passNodes.push(...item.nodes);

      }

    });

    

    // Procesar inapplicable

    inapplicable.forEach(item => {

      const criteriaKey = item.wcag?.criteria?.[0] || item.id;

      

      if (!grouped[criteriaKey]) {

        grouped[criteriaKey] = {

          criteria: criteriaKey,

          criteriaName: item.wcag?.criteriaNames?.[0] || '',

          level: item.wcag?.level || '',

          impact: item.impact,

          help: item.help,

          description: item.description,

          helpUrl: item.helpUrl,

          type: 'inapplicable',

          violationNodes: [],

          incompleteNodes: [],

          passNodes: [],

          inapplicableNodes: [],

          id: item.id,

          wcag: item.wcag,

          hasViolations: false,

          hasIncomplete: false,

          hasPasses: false,

          hasInapplicable: true

        };

      }

      

      grouped[criteriaKey].hasInapplicable = true;

      if (item.nodes) {

        if (!grouped[criteriaKey].inapplicableNodes) {

          grouped[criteriaKey].inapplicableNodes = [];

        }

        grouped[criteriaKey].inapplicableNodes.push(...item.nodes);

      }

    });

    

    return Object.values(grouped);

  };



  // Agrupar todos los items

  const groupedItems = groupAllByCriteria();



  // Función para extraer el número del criterio para ordenar

  const getCriteriaNumber = (criteria) => {

    if (!criteria) return 999999;

    const match = criteria.match(/^(\d+)\.(\d+)\.(\d+)/);

    if (match) {

      const [, major, minor, patch] = match;

      return parseInt(major) * 10000 + parseInt(minor) * 100 + parseInt(patch);

    }

    return 999999;

  };



  // Función para obtener el orden de prioridad del tipo

  const getTypePriority = (type) => {

    switch(type) {

      case 'violation': return 1;

      case 'incomplete': return 2;

      case 'pass': return 3;

      case 'inapplicable': return 4;

      default: return 5;

    }

  };



  // Ordenar: primero por tipo (violations -> incomplete -> passes) 

  // y luego por criterio (de menor a mayor)

  const allSortedItems = groupedItems.sort((a, b) => {

    const typeDiff = getTypePriority(a.type) - getTypePriority(b.type);

    if (typeDiff !== 0) return typeDiff;

    

    const numA = getCriteriaNumber(a.criteria);

    const numB = getCriteriaNumber(b.criteria);

    return numA - numB;

  });



  return (

    <Box

      sx={{

        display: "flex",

        flexDirection: "column",

        width: "100%",

        maxWidth: "100vw",

        px: { xs: 0, md: 2.5 },

        py: { xs: 0, md: 4 },

        pb: 0,

        mr: { xs: -6 },

        pr: { xs: 0 },

      }}

    >

      {/* Header fijo - NO incluido en el PDF */}

      <Box

        sx={{

          display: "flex",

          flexDirection: "column",

          width: "100%",

          position: "fixed",

          top: 0,

          left: 0,

          right: 0,

          padding: { xs: "12px 16px", sm: "8px 16px", md: "12px 16px" },

          boxShadow: "0 2px 10px rgba(0,0,0,0.1)",

          backgroundColor: "white",

          zIndex: 1000,

        }}

      >

        {/* Fila principal con título y botones */}

        <Box

          sx={{

            display: "flex",

            justifyContent: "space-between",

            alignItems: "center",

            width: "100%",

          }}

        >

          {/* Left: Volver + Título + URL */}

          <Box sx={{ 

            display: { xs: "flex", sm: "flex" }, 

            flexDirection: "row", 

            alignItems: "center",

            flex: 1,

            ml: { xs: "50px", sm: "50px", md: 35.5 },

            gap: 1,

          }}>

              <IconButton

                onClick={() => navigate('/dashboard/analizador')}

                sx={{

                  color: "#0F52BD",

                  "&:hover": { backgroundColor: "#E3F2FD" },

                  width: 40,

                  height: 40,

                }}

              >

                <ArrowBackIcon sx={{ fontSize: "24px" }} />

              </IconButton>

              

              <Box sx={{ display: "flex", flexDirection: "column" }}>

              <Typography

                variant="h5"

                sx={{

                  fontSize: { xs: "18px", sm: "16px", md: "14px", lg: "20px" },

                  fontWeight: "medium",

                  color: "#000",

                }}

              >

                {t('Reporte de')}{' '}

                <span style={{ color: "#0F52BD" }}>{t('accesibilidad')}</span>

              </Typography>

            <Typography

              variant="subtitle1"

              sx={{

                fontSize: { xs: "12px", sm: "15px", md: "14px" },

                color: "#666",

                mt: { xs: 0, md: 0.3 },

                display: { xs: "none", sm: "none", md: "none", lg: "block" },

              }}

            >

              {report.url || `${report.domain}${report.path}`}

            </Typography>

            </Box>

          </Box>



          {/* Right: Botones */}

          <Box

            sx={{

              display: "flex",

              gap: { xs: 1.5, sm: 2 },

              mr: { xs: 1.5, md: 5 },

              alignItems: "center",

            }}

          >

            <Box sx={{ ml: { xs: 1, sm: 0 } }}>

            <Button

              variant="contained"

              onClick={handleExportPDF}

              disabled={isGeneratingPDF || loading}

              sx={{

                textTransform: "none",

                fontWeight: "medium",

                backgroundColor: "#0F52BD",

                fontSize: { xs: "11px", sm: "12px", md: "12px" },

                px: { xs: 1.2, sm: 1.5, md: 1.5 },

                py: { xs: 0.6, sm: 0.8, md: 0.8 },

                borderRadius: "8px",

                display: "flex",

                gap: 0.5,

                "&:disabled": {

                  backgroundColor: "#9e9e9e",

                },

              }}

            >

              <DownloadIcon sx={{ fontSize: { xs: "18px", sm: "18px", md: "16px" } }} />

              <Box component="span" sx={{ display: { xs: "none", sm: "inline" } }}>

                {t('Descargar en')}

              </Box>

              PDF

            </Button>

            </Box>

          </Box>

        </Box>

      </Box>



      {/* Spacer para empujar el contenido hacia abajo */}

      <Box

        sx={{

          height: { xs: "65px", sm: "70px", md: "100px", lg: "90px" },

          "@media (max-width: 600px) and (min-resolution: 1.25dppx)": {

            height: "65px",

          },

          "@media (max-width: 600px) and (min-resolution: 1.5dppx)": {

            height: "90px",

          },

          "@media (min-width: 600px) and (min-resolution: 1.25dppx)": {

            height: "75px",

          },

          "@media (min-width: 900px) and (min-resolution: 1.25dppx)": {

            height: "95px",

          },

        }}

      />



      {/* Contenedor exportable - Inicia aquí el contenido para PDF */}

      <Box sx={{ ml: { xs: -6, md: 0 } }}>

        <Box sx={{ paddingLeft: { xs: 6, md: 2 }, paddingRight: { xs: 0, md: 4 } }}>

      <Box 

        ref={pdfRef}

        sx={{

          backgroundColor: '#ffffff',

          '& *': {

            boxSizing: 'border-box',

          },

        }}

      >

        {/* Selector de Fecha del informe */}

        <Box mb={3}>

        <Typography variant="body2" color="text.secondary" gutterBottom>

          {t('Fecha del informe')}

        </Typography>

        <TextField

          select

          value={report.analysis_date}

          size="small"

          sx={{

            minWidth: { xs: "200px", sm: "250px" },

            "& .MuiOutlinedInput-root": {

              borderRadius: "8px",

            },

          }}

        >

          <MenuItem value={report.analysis_date}>

            {new Date(report.analysis_date).toLocaleString('es-ES', {

              day: '2-digit',

              month: '2-digit',

              year: 'numeric',

              hour: '2-digit',

              minute: '2-digit',

              second: '2-digit'

            })}

          </MenuItem>

        </TextField>

      </Box>



      {/* Score Card */}

      <Grid container spacing={2} mb={3}>

        <Grid item xs={12} md={6}>

          <Paper

            elevation={0}

            sx={{

              p: 2.5,

              boxShadow: "0px 4px 10px 0px rgba(98, 113, 137, 0.46)",

              borderRadius: 2.5,

              height: "100%"

            }}

          >

            {/* Fila superior: Título + Chip */}

            <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>

              <Typography variant="h6" fontWeight="bold">

                {t('Puntuación obtenida')}

              </Typography>

              <Chip

                label={parseFloat(score) >= 90 ? t('Excelente') : parseFloat(score) >= 70 ? t('Bueno') : t('Necesita Mejoras')}

                color={parseFloat(score) >= 90 ? 'success' : parseFloat(score) >= 70 ? 'warning' : 'error'}

                icon={<CheckCircleIcon />}

              />

            </Box>



            {/* Fila principal: Grid horizontal */}

            <Grid container spacing={0} alignItems="center">

              {/* Columna izquierda: Score circular */}

              <Grid item xs={12} md={5}>

                <Box display="flex" justifyContent="center" alignItems="center" pr={{ md: 2 }}>

                  <Box position="relative" display="inline-flex">

                    <CircularProgress

                      variant="determinate"

                      value={parseFloat(score)}

                      size={160}

                      thickness={4}

                      sx={{ color: getScoreColor(parseFloat(score)) }}

                    />

                    <Box

                      position="absolute"

                      top={0}

                      left={0}

                      bottom={0}

                      right={0}

                      display="flex"

                      flexDirection="column"

                      alignItems="center"

                      justifyContent="center"

                    >

                      <Typography

                        variant="h2"

                        component="div"

                        fontWeight="bold"

                        sx={{ fontSize: '3rem', lineHeight: 1 }}

                      >

                        {score}

                      </Typography>

                      <Typography

                        variant="h6"

                        component="div"

                        sx={{ fontSize: '1.2rem', color: 'text.secondary', mt: -0.5 }}

                      >

                        /100

                      </Typography>

                    </Box>

                  </Box>

                </Box>

              </Grid>



              {/* Divider vertical */}

              <Divider

                orientation="vertical"

                flexItem

                sx={{

                  display: { xs: "none", md: "block" },

                  borderColor: "#0F52BD",

                  borderWidth: "1px",

                  mx: 2

                }}

              />



              {/* Columna derecha: Incumplimientos */}

              <Grid item xs={12} md={6}>

                {violations.length > 0 ? (

                  <Box pl={{ xs: 0, md: 2 }} mt={{ xs: 3, md: 0 }}>

                    <Typography variant="h6" fontWeight="bold" mb={2}>

                      {violations.length} {t('incumplimientos')}

                    </Typography>

                    <Stack spacing={0.8} alignItems="flex-start">

                      {Object.entries(

                        violations.reduce((acc, v) => {

                          acc[v.impact] = (acc[v.impact] || 0) + 1;

                          return acc;

                        }, {})

                      )

                        .sort((a, b) => {

                          const order = { critical: 0, serious: 1, moderate: 2, minor: 3 };

                          return order[a[0]] - order[b[0]];

                        })

                        .map(([impact, count]) => (

                          <Typography key={impact} variant="body2" color="text.secondary">

                            • {count} {t(`Gravedad ${impact === 'critical' ? 'crítica' : impact === 'serious' ? 'severa' : impact === 'moderate' ? 'moderada' : 'menor'}`)}

                          </Typography>

                        ))}

                    </Stack>

                  </Box>

                ) : (

                  <Box pl={{ xs: 0, md: 2 }} display="flex" alignItems="center" justifyContent="center" height="100%" mt={{ xs: 3, md: 0 }}>

                    <Typography variant="body1" color="success.main" fontWeight="500">

                      {t('¡Sin incumplimientos!')} 🎉

                    </Typography>

                  </Box>

                )}

              </Grid>

            </Grid>

          </Paper>

        </Grid>



        <Grid item xs={12} md={6}>

          <Grid container spacing={2}>

            {/* Incumplimientos */}

            <Grid item xs={12} sm={6}>

              <Paper

                elevation={0}

                sx={{

                  p: 2,

                  boxShadow: "0px 2px 8px 0px rgba(98, 113, 137, 0.3)",

                  borderRadius: 2,

                  height: "100%",

                  minHeight: "120px",

                  display: "flex",

                  flexDirection: "column"

                }}

              >

                <Box display="flex" alignItems="flex-start" gap={1.5} mb={0.5}>

                  <ErrorOutlineIcon sx={{ color: "#d32f2f", fontSize: 28, mt: 0.3 }} />

                  <Typography variant="h6" fontWeight="600" sx={{ fontSize: "16px", flex: 1 }}>

                    {t('Incumplimientos')}

                  </Typography>

                </Box>

                <Box sx={{ flexGrow: 1 }} />

                <Box display="flex" alignItems="baseline" justifyContent="space-between">

                  <Box display="flex" alignItems="baseline" gap={1}>

                    <Typography variant="h3" fontWeight="bold" sx={{ color: "#333", fontSize: "2.2rem" }}>

                      {summary.violations || 0}

                    </Typography>

                    <Typography variant="body2" color="text.secondary">

                      {t('Incumplimientos')}

                    </Typography>

                  </Box>

                  <Button

                    size="small"

                    onClick={() => scrollToItems('violation')}

                    sx={{

                      textTransform: "none",

                      p: 0,

                      color: "#0F52BD",

                      fontWeight: 500,

                      "&:hover": { backgroundColor: "transparent", textDecoration: "underline" }

                    }}

                  >

                    {t('Ver más')} ›

                  </Button>

                </Box>

              </Paper>

            </Grid>



            {/* Aprobados */}

            <Grid item xs={12} sm={6}>

              <Paper

                elevation={0}

                sx={{

                  p: 2,

                  boxShadow: "0px 2px 8px 0px rgba(98, 113, 137, 0.3)",

                  borderRadius: 2,

                  height: "100%",

                  minHeight: "120px",

                  display: "flex",

                  flexDirection: "column"

                }}

              >

                <Box display="flex" alignItems="flex-start" gap={1.5} mb={0.5}>

                  <CheckCircleOutlineIcon sx={{ color: "#2e7d32", fontSize: 28, mt: 0.3 }} />

                  <Typography variant="h6" fontWeight="600" sx={{ fontSize: "16px", flex: 1 }}>

                    {t('Aprobados')}

                  </Typography>

                </Box>

                <Box sx={{ flexGrow: 1 }} />

                <Box display="flex" alignItems="baseline" justifyContent="space-between">

                  <Box display="flex" alignItems="baseline" gap={1}>

                    <Typography variant="h3" fontWeight="bold" sx={{ color: "#333", fontSize: "2.2rem" }}>

                      {summary.passes || 0}

                    </Typography>

                    <Typography variant="body2" color="text.secondary">

                      {t('Aprobadas')}

                    </Typography>

                  </Box>

                  <Button

                    size="small"

                    onClick={() => scrollToItems('pass')}

                    sx={{

                      textTransform: "none",

                      p: 0,

                      color: "#0F52BD",

                      fontWeight: 500,

                      "&:hover": { backgroundColor: "transparent", textDecoration: "underline" }

                    }}

                  >

                    {t('Ver más')} ›

                  </Button>

                </Box>

              </Paper>

            </Grid>



            {/* Revisión manual */}

            <Grid item xs={12} sm={6}>

              <Paper

                elevation={0}

                sx={{

                  p: 2,

                  boxShadow: "0px 2px 8px 0px rgba(98, 113, 137, 0.3)",

                  borderRadius: 2,

                  height: "100%",

                  minHeight: "120px",

                  display: "flex",

                  flexDirection: "column"

                }}

              >

                <Box display="flex" alignItems="flex-start" gap={1.5} mb={0.5}>

                  <WarningAmberIcon sx={{ color: "#ed6c02", fontSize: 28, mt: 0.3 }} />

                  <Typography variant="h6" fontWeight="600" sx={{ fontSize: "16px", flex: 1 }}>

                    {t('Revisión manual')}

                  </Typography>

                </Box>

                <Box sx={{ flexGrow: 1 }} />

                <Box display="flex" alignItems="baseline" justifyContent="space-between">

                  <Box display="flex" alignItems="baseline" gap={1}>

                    <Typography variant="h3" fontWeight="bold" sx={{ color: "#333", fontSize: "2.2rem" }}>

                      {summary.incomplete || 0}

                    </Typography>

                    <Typography variant="body2" color="text.secondary">

                      {t('Incompletas')}

                    </Typography>

                  </Box>

                  <Button

                    size="small"

                    onClick={() => scrollToItems('incomplete')}

                    sx={{

                      textTransform: "none",

                      p: 0,

                      color: "#0F52BD",

                      fontWeight: 500,

                      "&:hover": { backgroundColor: "transparent", textDecoration: "underline" }

                    }}

                  >

                    {t('Ver más')} ›

                  </Button>

                </Box>

              </Paper>

            </Grid>



            {/* No aplica */}

            <Grid item xs={12} sm={6}>

              <Paper

                elevation={0}

                sx={{

                  p: 2,

                  boxShadow: "0px 2px 8px 0px rgba(98, 113, 137, 0.3)",

                  borderRadius: 2,

                  height: "100%",

                  minHeight: "120px",

                  display: "flex",

                  flexDirection: "column"

                }}

              >

                <Box display="flex" alignItems="flex-start" gap={1.5} mb={0.5}>

                  <Box

                    sx={{

                      width: 28,

                      height: 28,

                      display: "flex",

                      alignItems: "center",

                      justifyContent: "center",

                      border: "2px solid #757575",

                      borderRadius: "4px",

                      mt: 0.3

                    }}

                  >

                    <Typography sx={{ fontSize: "18px", color: "#757575", lineHeight: 1 }}>✕</Typography>

                  </Box>

                  <Typography variant="h6" fontWeight="600" sx={{ fontSize: "16px", flex: 1 }}>

                    {t('No aplica')}

                  </Typography>

                </Box>

                <Box sx={{ flexGrow: 1 }} />

                <Box display="flex" alignItems="baseline" justifyContent="space-between">

                  <Box display="flex" alignItems="baseline" gap={1}>

                    <Typography variant="h3" fontWeight="bold" sx={{ color: "#333", fontSize: "2.2rem" }}>

                      {summary.inapplicable || 0}

                    </Typography>

                    <Typography variant="body2" color="text.secondary">

                      {t('No aplicables')}

                    </Typography>

                  </Box>

                  <Button

                    size="small"

                    onClick={() => scrollToItems('inapplicable')}

                    sx={{

                      textTransform: "none",

                      p: 0,

                      color: "#0F52BD",

                      fontWeight: 500,

                      "&:hover": { backgroundColor: "transparent", textDecoration: "underline" }

                    }}

                  >

                    {t('Ver más')} ›

                  </Button>

                </Box>

              </Paper>

            </Grid>

          </Grid>

        </Grid>

      </Grid>



      {/* Sección de todos los items agrupados y ordenados */}

      {allSortedItems.length > 0 && (

        <Box mb={3} ref={itemsSectionRef}>

          {/* Header con título */}

          <Box mb={2}>

            <Typography variant="h5" fontWeight="600">

              {t('Detalle de tests')}

            </Typography>

          </Box>

          

          {/* Filtros activos */}

          {filterType && (

            <Box mb={2} display="flex" alignItems="center" gap={1}>

              <Chip

                label={t(

                  filterType === 'violation' ? 'Incumplimientos' :

                  filterType === 'pass' ? 'Aprobados' :

                  filterType === 'incomplete' ? 'Revisión manual' :

                  'No aplica'

                )}

                onDelete={() => setFilterType(null)}

                color="primary"

                variant="outlined"

              />

              <Typography variant="body2" color="text.secondary">

                {allSortedItems.filter(item => 

                  filterType === 'inapplicable' ? item.type === 'inapplicable' : item.type === filterType

                ).length} {t('resultados')}

              </Typography>

            </Box>

          )}

          <Stack spacing={2}>

            {allSortedItems

              .filter(item => !filterType || (filterType === 'inapplicable' ? item.type === 'inapplicable' : item.type === filterType))

              .map((item, index) => {

              const cardId = `item-${item.type}-${item.criteria}-${index}`;

              const isExpanded = expandedCards[cardId];

              const elementsAffected = (item.violationNodes?.length || 0) + (item.incompleteNodes?.length || 0) + (item.passNodes?.length || 0);

              

              // Determinar el icono según el tipo

              let icon;

              let statusLabel;

              let scoreDisplay;

              

              if (item.type === 'violation') {

                icon = getSeverityIcon(item.impact);

                statusLabel = t('Incumple');

                scoreDisplay = <Typography variant="body2" fontWeight="600" color="error">0</Typography>;

              } else if (item.type === 'incomplete') {

                icon = <WarningAmberIcon sx={{ color: "#ed6c02", fontSize: 28 }} />;

                statusLabel = t('Revisión manual');

                scoreDisplay = <Typography variant="body2" fontWeight="500">-</Typography>;

              } else if (item.type === 'inapplicable') {

                icon = (

                  <Box

                    sx={{

                      width: 28,

                      height: 28,

                      display: "flex",

                      alignItems: "center",

                      justifyContent: "center",

                      border: "2px solid #757575",

                      borderRadius: "4px"

                    }}

                  >

                    <Typography sx={{ fontSize: "18px", color: "#757575", lineHeight: 1 }}>✕</Typography>

                  </Box>

                );

                statusLabel = t('No aplica');

                scoreDisplay = <Typography variant="body2" fontWeight="500" color="text.secondary">N/A</Typography>;

              } else {

                icon = <CheckCircleOutlineIcon sx={{ color: "#2e7d32", fontSize: 28 }} />;

                statusLabel = t('Aprobado');

                scoreDisplay = <Chip label="100" color="success" size="small" sx={{ height: "24px", fontSize: "12px", fontWeight: "600" }} />;

              }



              const impactLabel = item.impact === 'critical' ? t('Crítica') :

                                 item.impact === 'serious' ? t('Severa') :

                                 item.impact === 'moderate' ? t('Moderada') : 

                                 item.impact === 'minor' ? t('Menor') : '-';



              // Determinar si hay múltiples estados para mostrar un mensaje informativo

              const hasMultipleStates = (item.hasViolations ? 1 : 0) + (item.hasIncomplete ? 1 : 0) + (item.hasPasses ? 1 : 0) > 1;

              let multipleStatesMessage = '';

              if (hasMultipleStates) {

                const states = [];

                if (item.hasViolations) states.push(t('incumplimientos'));

                if (item.hasIncomplete) states.push(t('revisiones manuales'));

                if (item.hasPasses) states.push(t('elementos aprobados'));

                multipleStatesMessage = `${t('Este criterio contiene')}: ${states.join(', ')}`;

              }



              return (

                <Paper

                  key={cardId}

                  elevation={0}

                  sx={{

                    p: 2.5,

                    boxShadow: "0px 2px 8px 0px rgba(98, 113, 137, 0.3)",

                    borderRadius: 2,

                  }}

                >

                  {/* Data Row - Table Format */}

                  <Grid container spacing={2} alignItems="center" mb={1.5}>

                    {/* Icono + Título */}

                    <Grid item xs={12} md={3.6}>

                      <Box display="flex" alignItems="center" gap={1.5}>

                        {icon}

                        <Typography variant="body1" fontWeight="600">

                          {item.criteria && item.criteriaName && (

                            <>

                              {item.criteria} {t(`wcagCriteria.${item.criteriaName}`)} Nivel {item.level}

                            </>

                          )}

                          {!item.criteria && item.id}

                        </Typography>

                      </Box>

                    </Grid>



                    {/* Aplica */}

                    <Grid item xs={6} sm={2.4} md={1.2}>

                      <Typography variant="body2" color="text.secondary" sx={{ fontSize: "12px", mb: 0.3 }}>

                        {t('Aplica')}

                      </Typography>

                      <Typography variant="body2" fontWeight="500">

                        {item.type === 'inapplicable' ? t('No') : t('Sí')}

                      </Typography>

                    </Grid>



                    {/* Elementos afectados */}

                    <Grid item xs={6} sm={2.4} md={1.8}>

                      <Typography variant="body2" color="text.secondary" sx={{ fontSize: "12px", mb: 0.3 }}>

                        {t('Elementos afectados')}

                      </Typography>

                      <Typography variant="body2" fontWeight="500">

                        {elementsAffected}

                      </Typography>

                    </Grid>



                    {/* Gravedad */}

                    <Grid item xs={6} sm={2.4} md={1.8}>

                      <Typography variant="body2" color="text.secondary" sx={{ fontSize: "12px", mb: 0.3 }}>

                        {t('Gravedad')}

                      </Typography>

                      {item.type === 'violation' && item.impact ? (

                        <Chip

                          label={impactLabel}

                          color={getSeverityColor(item.impact)}

                          size="small"

                          sx={{ height: "24px", fontSize: "12px" }}

                        />

                      ) : (

                        <Typography variant="body2" fontWeight="500">

                          -

                        </Typography>

                      )}

                    </Grid>



                    {/* Estado */}

                    <Grid item xs={6} sm={2.4} md={1.8}>

                      <Typography variant="body2" color="text.secondary" sx={{ fontSize: "12px", mb: 0.3 }}>

                        {t('Estado')}

                      </Typography>

                      <Typography variant="body2" fontWeight="500">

                        {statusLabel}

                      </Typography>

                    </Grid>



                    {/* Puntuación */}

                    <Grid item xs={6} sm={2.4} md={1.8}>

                      <Typography variant="body2" color="text.secondary" sx={{ fontSize: "12px", mb: 0.3 }}>

                        {t('Puntuación')}

                      </Typography>

                      {scoreDisplay}

                    </Grid>

                  </Grid>



                  {/* Divider */}

                  <Divider sx={{ mb: 2, borderColor: "#0F52BD", borderWidth: "1px" }} />



                  {/* Mensaje informativo si hay múltiples estados */}

                  {hasMultipleStates && (

                    <Alert severity="info" sx={{ mb: 2, py: 0.5 }}>

                      <Typography variant="body2" sx={{ fontSize: "13px" }}>

                        {multipleStatesMessage}

                      </Typography>

                    </Alert>

                  )}



                  {/* Description */}

                  <Typography variant="body2" color="text.secondary" mb={2}>

                    {t(`axeRules.${item.id}.help`, { defaultValue: item.help })}

                  </Typography>



                  {/* Ver más button */}

                  <Button

                    size="small"

                    onClick={() => toggleCardExpansion(cardId)}

                    sx={{

                      textTransform: "none",

                      p: 0,

                      color: "#0F52BD",

                      fontWeight: 500,

                      "&:hover": { backgroundColor: "transparent", textDecoration: "underline" }

                    }}

                  >

                    {isExpanded ? t('Ver menos') : t('Ver más')} {isExpanded ? '‹' : '›'}

                  </Button>



                  {/* Expanded content */}

                  {isExpanded && (

                    <Box mt={2} pt={2} borderTop="1px solid #e0e0e0">

                      <Typography variant="body2" gutterBottom>

                        <strong>{t('Descripción completa')}:</strong> {t(`axeRules.${item.id}.description`, { defaultValue: item.description })}

                      </Typography>



                      {/* Sección de incumplimientos */}

                      {item.violationNodes && item.violationNodes.length > 0 && (

                        <Box mt={3}>

                          <Box display="flex" alignItems="center" gap={1} mb={1.5}>

                            <ErrorOutlineIcon sx={{ color: "#d32f2f", fontSize: 20 }} />

                            <Typography variant="body2" fontWeight="600" color="error">

                              {t('Incumplimientos')} ({item.violationNodes.length})

                            </Typography>

                          </Box>

                          <Stack spacing={1.5}>

                            {item.violationNodes.map((node, nodeIndex) => (

                              <Box

                                key={`violation-${nodeIndex}`}

                                sx={{

                                  position: "relative",

                                  backgroundColor: "#ffebee",

                                  borderRadius: 1,

                                  border: "1px solid #ef9a9a",

                                  overflow: "hidden"

                                }}

                              >

                                <Box

                                  sx={{

                                    display: "flex",

                                    alignItems: "center",

                                    justifyContent: "space-between",

                                    px: 2,

                                    py: 0.5,

                                    backgroundColor: "#ffcdd2",

                                    borderBottom: "1px solid #ef9a9a"

                                  }}

                                >

                                  <Typography variant="caption" color="error" fontWeight="500">

                                    {t('Elemento')} {nodeIndex + 1}

                                  </Typography>

                                  <IconButton

                                    size="small"

                                    onClick={() => {

                                      navigator.clipboard.writeText(node.html || node.target?.join(', ') || '');

                                    }}

                                    sx={{ padding: 0.5 }}

                                  >

                                    <ShareIcon sx={{ fontSize: 16 }} />

                                  </IconButton>

                                </Box>

                                <Box

                                  sx={{

                                    px: 2,

                                    py: 1.5,

                                    overflowX: "auto",

                                    maxHeight: "200px"

                                  }}

                                >

                                  <Typography

                                    variant="body2"

                                    component="pre"

                                    sx={{

                                      fontFamily: "monospace",

                                      fontSize: "12px",

                                      whiteSpace: "pre-wrap",

                                      wordBreak: "break-word",

                                      margin: 0

                                    }}

                                  >

                                    {node.html || node.target?.join(', ') || t('No hay fragmento de código disponible')}

                                  </Typography>

                                </Box>

                              </Box>

                            ))}

                          </Stack>

                        </Box>

                      )}



                      {/* Sección de revisiones manuales */}

                      {item.incompleteNodes && item.incompleteNodes.length > 0 && (

                        <Box mt={3}>

                          <Box display="flex" alignItems="center" gap={1} mb={1.5}>

                            <WarningAmberIcon sx={{ color: "#ed6c02", fontSize: 20 }} />

                            <Typography variant="body2" fontWeight="600" sx={{ color: "#ed6c02" }}>

                              {t('Revisión manual')} ({item.incompleteNodes.length})

                            </Typography>

                          </Box>

                          <Stack spacing={1.5}>

                            {item.incompleteNodes.map((node, nodeIndex) => (

                              <Box

                                key={`incomplete-${nodeIndex}`}

                                sx={{

                                  position: "relative",

                                  backgroundColor: "#fff3e0",

                                  borderRadius: 1,

                                  border: "1px solid #ffb74d",

                                  overflow: "hidden"

                                }}

                              >

                                <Box

                                  sx={{

                                    display: "flex",

                                    alignItems: "center",

                                    justifyContent: "space-between",

                                    px: 2,

                                    py: 0.5,

                                    backgroundColor: "#ffe0b2",

                                    borderBottom: "1px solid #ffb74d"

                                  }}

                                >

                                  <Typography variant="caption" sx={{ color: "#ed6c02" }} fontWeight="500">

                                    {t('Elemento')} {nodeIndex + 1}

                                  </Typography>

                                  <IconButton

                                    size="small"

                                    onClick={() => {

                                      navigator.clipboard.writeText(node.html || node.target?.join(', ') || '');

                                    }}

                                    sx={{ padding: 0.5 }}

                                  >

                                    <ShareIcon sx={{ fontSize: 16 }} />

                                  </IconButton>

                                </Box>

                                <Box

                                  sx={{

                                    px: 2,

                                    py: 1.5,

                                    overflowX: "auto",

                                    maxHeight: "200px"

                                  }}

                                >

                                  <Typography

                                    variant="body2"

                                    component="pre"

                                    sx={{

                                      fontFamily: "monospace",

                                      fontSize: "12px",

                                      whiteSpace: "pre-wrap",

                                      wordBreak: "break-word",

                                      margin: 0

                                    }}

                                  >

                                    {node.html 

                                      ? node.html 
                                      : node.target?.length > 0 
                                        ? node.target.join(', ') 
                                        : t('No hay fragmento de código disponible')}
                                  </Typography>
                                </Box>
                              </Box>
                            ))}

                          </Stack>

                        </Box>

                      )}



                      {/* Sección de aprobados */}

                      {item.passNodes && item.passNodes.length > 0 && (

                        <Box mt={3}>

                          <Box display="flex" alignItems="center" gap={1} mb={1.5}>

                            <CheckCircleOutlineIcon sx={{ color: "#2e7d32", fontSize: 20 }} />

                            <Typography variant="body2" fontWeight="600" color="success.main">

                              {t('Aprobados')} ({item.passNodes.length})

                            </Typography>

                          </Box>

                          <Stack spacing={1.5}>

                            {item.passNodes.map((node, nodeIndex) => (

                              <Box

                                key={`pass-${nodeIndex}`}

                                sx={{

                                  position: "relative",

                                  backgroundColor: "#e8f5e9",

                                  borderRadius: 1,

                                  border: "1px solid #81c784",

                                  overflow: "hidden"

                                }}

                              >

                                <Box

                                  sx={{

                                    display: "flex",

                                    alignItems: "center",

                                    justifyContent: "space-between",

                                    px: 2,

                                    py: 0.5,

                                    backgroundColor: "#c8e6c9",

                                    borderBottom: "1px solid #81c784"

                                  }}

                                >

                                  <Typography variant="caption" color="success.main" fontWeight="500">

                                    {t('Elemento')} {nodeIndex + 1}

                                  </Typography>

                                  <IconButton

                                    size="small"

                                    onClick={() => {

                                      navigator.clipboard.writeText(node.html || node.target?.join(', ') || '');

                                    }}

                                    sx={{ padding: 0.5 }}

                                  >

                                    <ShareIcon sx={{ fontSize: 16 }} />

                                  </IconButton>

                                </Box>

                                <Box

                                  sx={{

                                    px: 2,

                                    py: 1.5,

                                    overflowX: "auto",

                                    maxHeight: "200px"

                                  }}

                                >

                                  <Typography

                                    variant="body2"

                                    component="pre"

                                    sx={{

                                      fontFamily: "monospace",

                                      fontSize: "12px",

                                      whiteSpace: "pre-wrap",

                                      wordBreak: "break-word",

                                      margin: 0

                                    }}

                                  >

                                    {node.html || node.target?.join(', ') || t('No hay fragmento de código disponible')}

                                  </Typography>

                                </Box>

                              </Box>

                            ))}

                          </Stack>

                        </Box>

                      )}



                      {/* Sección de no aplicables */}

                      {item.inapplicableNodes && item.inapplicableNodes.length > 0 && (

                        <Box mt={3}>

                          <Box display="flex" alignItems="center" gap={1} mb={1.5}>

                            <Box

                              sx={{

                                width: 20,

                                height: 20,

                                display: "flex",

                                alignItems: "center",

                                justifyContent: "center",

                                border: "2px solid #757575",

                                borderRadius: "4px"

                              }}

                            >

                              <Typography sx={{ fontSize: "14px", color: "#757575", lineHeight: 1 }}>✕</Typography>

                            </Box>

                            <Typography variant="body2" fontWeight="600" sx={{ color: "#757575" }}>

                              {t('No aplica')} ({item.inapplicableNodes.length})

                            </Typography>

                          </Box>

                          <Stack spacing={1.5}>

                            {item.inapplicableNodes.map((node, nodeIndex) => (

                              <Box

                                key={`inapplicable-${nodeIndex}`}

                                sx={{

                                  position: "relative",

                                  backgroundColor: "#f5f5f5",

                                  borderRadius: 1,

                                  border: "1px solid #bdbdbd",

                                  overflow: "hidden"

                                }}

                              >

                                <Box

                                  sx={{

                                    display: "flex",

                                    alignItems: "center",

                                    justifyContent: "space-between",

                                    px: 2,

                                    py: 0.5,

                                    backgroundColor: "#e0e0e0",

                                    borderBottom: "1px solid #bdbdbd"

                                  }}

                                >

                                  <Typography variant="caption" sx={{ color: "#757575" }} fontWeight="500">

                                    {t('Elemento')} {nodeIndex + 1}

                                  </Typography>

                                  <IconButton

                                    size="small"

                                    onClick={() => {

                                      navigator.clipboard.writeText(node.html || node.target?.join(', ') || '');

                                    }}

                                    sx={{ padding: 0.5 }}

                                  >

                                    <ShareIcon sx={{ fontSize: 16 }} />

                                  </IconButton>

                                </Box>

                                <Box

                                  sx={{

                                    px: 2,

                                    py: 1.5,

                                    overflowX: "auto",

                                    maxHeight: "200px"

                                  }}

                                >

                                  <Typography

                                    variant="body2"

                                    component="pre"

                                    sx={{

                                      fontFamily: "monospace",

                                      fontSize: "12px",

                                      whiteSpace: "pre-wrap",

                                      wordBreak: "break-word",

                                      margin: 0

                                    }}

                                  >

                                    {node.html || node.target?.join(', ') || t('No hay fragmento de código disponible')}

                                  </Typography>

                                </Box>

                              </Box>

                            ))}

                          </Stack>

                        </Box>

                      )}



                      {item.helpUrl && (

                        <Button

                          size="small"

                          variant="text"

                          href={item.helpUrl}

                          target="_blank"

                          rel="noopener noreferrer"

                          sx={{ mt: 2, color: "#0F52BD" }}

                        >

                          {t('Más información')} ›

                        </Button>

                      )}

                    </Box>

                  )}

                </Paper>

              );

            })}

          </Stack>

        </Box>

      )}



      </Box>

      {/* Fin del contenedor exportable */}

        </Box>

      </Box>



      {/* Snackbar para notificaciones - NO incluido en el PDF */}

      <Snackbar

        open={snackbarOpen}

        autoHideDuration={3000}

        onClose={handleSnackbarClose}

        message={snackbarMessage}

        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}

      />

    </Box>

  );

};



export default DetalleAnalisis;
